import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  message,
  Row,
  Select,
  Table,
} from "antd";
import { get, size, map, find, sumBy, round, r } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import services from "services";
import { useParams } from "react-router-dom";
import { filterOption } from "core/helpers";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import dayjs from "dayjs";
const { Option } = Select;
const CARD_STYLE = {
  borderRadius: "0.42rem",
  boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)",
};
let searchTimer = null;

const incidentType = {
  UNDETERMINED: "Chưa xác định",
  COMMUNICATIVE: "Truyền thông",
  ELECTRONIC: "Điện tử",
  MECHANICAL: "Cơ",
  ELECTRICAL: "Điện",
};
const DeviceDetailPage = () => {
  let { station, device } = useParams();
  const listStation = useSelector(
    (x) => x.app.listUserStartLvStationFromAdmcsm
  );
  const [form] = Form.useForm();
  const [selectedWeek, setSelectedWeek] = useState([
    dayjs().add(-8, "week").startOf("week"),
    dayjs().endOf("week"),
  ]);
  const [isFetching, setIsFetching] = useState(false);
  const [tableConfig, setTableConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
      showSizeChanger: true,
    },
  });
  const [tableData, setTableData] = useState({
    dataSource: [],
    total: 0,
  });

  const [trendData, setTrendData] = useState({
    chart: {
      type: "line", // Loại biểu đồ là line chart
      style: {
        fontFamily: "Roboto", // Áp dụng font Roboto cho toàn bộ chart
      },
    },
    title: {
      text: "Xu hướng lỗi", // Tiêu đề của biểu đồ
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          fontFamily: "Roboto", // Font cho các nhãn trục X
        },
        labels: {
          formatter: function () {
            return `Week ${this.value}`; // Prefix "Week" to each value
          },
        },
      },
    },
    yAxis: {
      title: {
        text: "", // Tiêu đề trục Y
      },
    },
    series: [],
    credits: {
      enabled: false, // Tắt logo "Highcharts" trong góc phải
    },
    exporting: {
      enabled: false,
    },
  });
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [totalStatistic, setTotalStatistic] = useState({
    health: {
      colors: [],
      exporting: {
        enabled: false,
      },
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0,
        },
        height: 350,
        style: {
          fontFamily: "Roboto",
        },
      },
      title: {
        text: `Sức khỏe thiết bị`,
        style: {
          fontSize: 16,
        },
      },
      legend: {
        align: "center",
        verticalAlign: "bottom",
        floating: false,
        backgroundColor: "white",
        borderColor: "#CCC",
        borderWidth: 0,
        shadow: false,
      },
      tooltip: {
        headerFormat: "<b>{point.key}</b><br/>{point.y} thiết bị",
        pointFormat: null,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          depth: 35,
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.y}",
          },
          showInLegend: true,
        },
      },
      series: [
        {
          data: [],
          dataLabels: {
            verticalAlign: "center",
            enabled: false,
          },
        },
      ],
    },
    status: {
      exporting: {
        enabled: false,
      },
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0,
        },
        height: 350,
        style: {
          fontFamily: "Roboto",
        },
      },
      title: {
        text: `Trạng thái`,
        style: {
          fontSize: 16,
        },
      },
      legend: {
        align: "center",
        verticalAlign: "bottom",
        floating: false,
        backgroundColor: "white",
        borderColor: "#CCC",
        borderWidth: 0,
        shadow: false,
      },
      tooltip: {
        headerFormat: "<b>{point.key}</b><br/>{point.y} thiết bị",
        pointFormat: null,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          depth: 35,
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.y}",
          },
          showInLegend: true,
        },
      },
      series: [
        {
          data: [],
          dataLabels: {
            verticalAlign: "center",
            enabled: true,
          },
        },
      ],
    },
    incident_rate: 0,
    incident_rate_avg: 0,
  });

  let rowKey = (record) => `${record.device_id}`;
  let columns = [
    {
      title: "Mã thiết bị",
      dataIndex: "device_id",
      align: "center",
    },
    {
      title: "Sức khỏe",
      dataIndex: "heo",
      align: "center",
      render: () => "N/A",
    },
    {
      title: "Trạng thái",
      dataIndex: "total_incident",
      align: "center",
      render: (value) => (value ? "Không lỗi" : "Đang lỗi"),
    },
    {
      title: "Tiếp nhận lỗi",
      dataIndex: "no",
      align: "center",
      render: (value, item) =>
        `${item.receive_incident} of ${item.total_incident}`,
    },
  ];

  const onValuesChange = (changedValue, values) => {
    if (values.station_id && values.device_type) {
      window.history.pushState(
        {},
        "",
        `/system/admin/dashboard-device/${values.station_id.value}/${values.device_type}`
      );
    }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      setTableConfig((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, current: 1 },
      }));
    }, 500);
  };

  const onChangeTable = (pagination) => {
    setTableConfig((prev) => ({ ...prev, pagination }));
  };

  const onRefresh = () => {
    setTableConfig((prev) => ({
      ...prev,
      pagination: { ...prev.pagination },
    }));
  };

  const search = useCallback(async (params) => {
    if (!params.station_id || !params.device_type) return;
    setIsFetching(true);
    let res = await services.GdmsService.getCmmmsTrendDevice(params);
    if (res?.success === false) {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin."));
    } else {
      let data = get(res, "data", []);
      setTableData((prev) => {
        let next = { ...prev };
        next.dataSource = get(res, "data", []);
        return next;
      });
      let total_receive_i = sumBy(data, (x) => x.receive_incident);
      let total_total_i = sumBy(data, (x) => x.total_incident);
      let incident_rate = total_total_i
        ? round((total_receive_i / total_total_i) * 100, 1)
        : 0;
      let statusSeries = [
        {
          name: "Lỗi đã tiếp nhận",
          y: total_receive_i,
          color: "#FF5733", // Màu sắc cho từng phần tử
        },
        {
          name: "Tổng số lỗi",
          y: total_total_i,
          color: "#33C1FF", // Màu sắc cho từng phần tử
        },
      ];
      let healthSeries = [
        {
          name: "Tốt",
          y: total_receive_i,
          color: "#FF5733", // Màu sắc cho từng phần tử
        },
        {
          name: "Bình thường",
          y: total_total_i,
          color: "#33C1FF", // Màu sắc cho từng phần tử
        },
        {
          name: "Hỏng",
          y: 19,
          color: "#aadd", // Màu sắc cho từng phần tử
        },
      ];
      setTotalStatistic((prev) => {
        let next = { ...prev };
        next.incident_rate = incident_rate;
        next.status = {
          ...next.status,
          series: [
            {
              data: statusSeries,
              dataLabels: {
                verticalAlign: "center",
                enabled: false,
              },
            },
          ],
        };
        next.health = {
          ...next.health,
          series: [
            {
              data: healthSeries,
              dataLabels: {
                verticalAlign: "center",
                enabled: false,
              },
            },
          ],
        };
        return next;
      });
    }

    setIsFetching(false);
  }, []);

  useEffect(() => {
    let params = {
      station_id: (form.getFieldValue("station_id") || undefined)?.value,
      device_type: form.getFieldValue("device_type") || undefined,
      sort: "deviceId,asc",
    };

    search(params).then((r) => r);
  }, [form, tableConfig, search]);
  useEffect(() => {
    let params = {
      station_id: (form.getFieldValue("station_id") || undefined)?.value,
      device_type: form.getFieldValue("device_type") || undefined,
    };
    if (!params.station_id || !params.device_type) return;
    if (!selectedWeek || size(selectedWeek) < 2) return;
    services.GdmsService.getCmmmsIncidentTypeWeeklyTrend({
      ...params,
      start_date: selectedWeek[0].format("YYYY-MM-DD"),
      end_date: selectedWeek[1].format("YYYY-MM-DD"),
    }).then((r) => {
      let data = get(r, "data", []);

      // Extract weeks for the x-axis
      const weeks = data.map((entry) => entry.week);
      // Extract unique types from details
      const uniqueTypes = [
        ...new Set(
          data.flatMap((entry) => entry.details.map((detail) => detail.type))
        ),
      ];

      // Create series data
      const series = uniqueTypes.map((type) => {
        return {
          name: incidentType[type],
          data: weeks.map((week) => {
            // Find the detail matching the type and week
            const entry = data.find((d) => d.week === week);
            const detail = entry?.details.find((d) => d.type === type);
            return detail ? detail.count : 0; // Use 0 if no data
          }),
        };
      });

      let sumLastWeek = sumBy(
        get(data, `${size(data) - 1}.details`, []),
        (x) => x.count
      );
      let sumPrevWeeks = 0;
      let countPrevWeek = 0;
      for (let index = 0; index < size(data); index++) {
        const details = get(data, `${index}.details`, []);
        sumPrevWeeks += sumBy(details, (x) => x.count);
        countPrevWeek++;
      }
      let avgPrevWeek = sumPrevWeeks / countPrevWeek;
      let per = avgPrevWeek
        ? ((sumLastWeek - avgPrevWeek) / avgPrevWeek) * 100
        : 0;
      let absPer = round(Math.abs(per), 1);
      setTotalStatistic((prev) => {
        return {
          ...prev,
          incident_rate_avg: per > 0 ? `tăng ${absPer}` : `giảm ${absPer}`,
        };
      });
      setTrendData((prev) => {
        let next = { ...prev };
        next.series = series;
        next.xAxis = {
          ...next.xAxis,
          categories: weeks.map((entry) => `Tuần ${entry}`),
        };
        return next;
      });
    });
  }, [form, selectedWeek, tableConfig]);

  let setDefaultData = useCallback(() => {
    if (device) {
      form.setFieldValue("device_type", device);
    }
    if (size(listStation) > 0) {
      if (station) {
        let findedStation = find(listStation, (x) => x.value == station);
        if (findedStation) {
          form.setFieldValue("station_id", findedStation);
          setTableConfig((prev) => ({
            ...prev,
            pagination: { ...prev.pagination },
          }));
        }
      }
    }
  }, [listStation, form, station, device]);
  useEffect(() => {
    setDefaultData();
  }, [setDefaultData]);
  useEffect(() => {
    services.GdmsService.getAssetType().then((r) => {
      setDeviceTypes(get(r, "data", []));
    });
  }, [setDefaultData]);

  const onChangeWeek = (e) => {
    setSelectedWeek(e);
  };
  const disableFutureWeeks = (current) => {
    // Disable dates greater than today
    return current && current > dayjs().endOf("week");
  };
  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Card size="small">
          <Form form={form} layout="vertical" onValuesChange={onValuesChange}>
            <Row gutter={[8]} align="bottom">
              <Col xl={4} xs={24}>
                <Form.Item name="station_id" label="Kho" className="mb-0">
                  <Select
                    filterOption={(inputValue, option) =>
                      filterOption(inputValue, option.label)
                    }
                    placeholder="Chọn kho"
                    allowClear
                    labelInValue
                    showSearch
                    options={listStation}
                  />
                </Form.Item>
              </Col>
              <Col xl={4} xs={24}>
                <Form.Item
                  name="device_type"
                  label="Loại thiết bị"
                  className="mb-0"
                >
                  <Select
                    placeholder="Chọn loại thiết bị"
                    showSearch
                    options={map(deviceTypes, (x) => ({
                      label: x.name,
                      value: x.code,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Button type="primary" onClick={() => {}}>
                  Cập nhật
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Table
              size="small"
              columns={columns}
              loading={isFetching}
              bordered
              dataSource={tableData.dataSource}
              rowKey={rowKey}
              pagination={false}
              onChange={onChangeTable}
              scroll={{
                x: "max-content",
                y: 600,
              }}
            />
          </Col>
          <Col span={24}>
            <div className="font-weight-bold">
              Tỷ lệ tiếp nhận Incident:
              <span className="text-danger ml-2">
                {totalStatistic.incident_rate}%
              </span>
            </div>
          </Col>
          <Col span={24}>
            <div className="font-weight-bold mt-2">
              Tỷ lệ lỗi tuần này
              <span className="text-danger mx-2">
                {totalStatistic.incident_rate_avg}%
              </span>
              so với trung bình 8 tuần
            </div>
          </Col>
          <Col span={12}>
            <div style={CARD_STYLE} className="w-100">
              <HighchartsReact
                highcharts={Highcharts}
                options={totalStatistic.health}
              />
            </div>
          </Col>
          <Col span={12}>
            <div style={CARD_STYLE} className="w-100">
              <HighchartsReact
                highcharts={Highcharts}
                options={totalStatistic.status}
              />
            </div>
          </Col>
          <Col span={24}>
            <div>
              <span className="font-weight-bold mr-2">Tuần</span>
              <DatePicker.RangePicker
                picker="week"
                value={selectedWeek}
                onChange={onChangeWeek}
                disabledDate={disableFutureWeeks}
              />
            </div>
          </Col>
          <Col span={24}>
            <div style={CARD_STYLE} className="w-100">
              <HighchartsReact highcharts={Highcharts} options={trendData} />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DeviceDetailPage;
